import { makeStyles } from '@material-ui/core/styles';

export const useStyles = (isDownloaded) => 
    makeStyles((theme) => ({
        document: {
            position: 'relative',
            display: 'flex',
            flexWrap: 'wrap',
            backgroundColor: isDownloaded ? 'transparent' : theme.library.requiredColor,

            ['@media only screen and (max-width: 640px)']: {
                padding: theme.spacing(1),
            },
        },
        downloadStatus: {
            position: 'static',
            fontSize: '14px',
            order: 1,
            textAlign: 'right',
            flex: '1 1 25%',
            transform: 'none',

            ['@media only screen and (max-width: 640px)']: {
                flexBasis: '100%',
                textAlign: 'left',
            },
        },
        text: {
            flex: '1 1 75%',

            ['@media only screen and (max-width: 640px)']: {
                flexBasis: '100%',
                marginBottom: 0,
            },
        },
    }));
